import { KEY, Resource } from "shelving";
import { PROFILE_FORM_SCHEMA } from "shared/schema";

export const EDIT_PROFILE_SETTINGS = new Resource("editProfileSettings", PROFILE_FORM_SCHEMA);
export const FOLLOW_USER = new Resource("followUser", KEY);
export const UNFOLLOW_USER = new Resource("unfollowUser", KEY);
export const APPROVE_FOLLOWER = new Resource("approveFollower", KEY);
export const REJECT_FOLLOWER = new Resource("rejectFollower", KEY);
export const BLOCK_USER = new Resource("blockUser", KEY);
export const UNBLOCK_USER = new Resource("unblockUser", KEY);
export const DELETE_PROFILE = new Resource("deleteProfile");
